<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form>
        <v-row>
          <!-- TT ALLOCATION MASTER INFO -->
          <v-col cols="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  TT Allocation
                </v-expansion-panel-title>

                <v-expansion-panel-text class="px-2">
                  <v-row dense class="mt-3">
                    <!-- Master Sales Contact -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Master Sales Contact*"
                        v-model="master_sales_contact_id"
                        :items="masterSalesContactList"
                        item-title="code"
                        item-value="id"
                        :error-messages="errors.master_sales_contact_id"
                        density="compact"
                        variant="outlined"
                        clearable
                        @update:model-value="changeMasterSalesContact"
                      />
                    </v-col>

                    <!-- Buyer -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Buyer*"
                        v-model="buyer_id"
                        :items="buyerList"
                        item-title="name"
                        item-value="id" 
                        :error-messages="errors.buyer_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <!-- Buying House Bank -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Buying House Bank*"
                        v-model="buying_house_bank_id"
                        :items="bankList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.buying_house_bank_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <!-- FTT Reference -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="FTT Reference*"
                        v-model="ftt_reference"
                        :error-messages="errors.ftt_reference"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <!-- TT Utilization Amount -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="TT Utilization Amount*"
                        type="number"
                        v-model.number="tt_utilization_amount"
                        :error-messages="errors.tt_utilization_amount"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <!-- First Beneficiary Amount -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="First Beneficiary Amount*"
                        type="number"
                        v-model.number="first_beneficiary_amount"
                        :error-messages="errors.first_beneficiary_amount"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <!-- Second Sales Contact -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Second Sales Contact*"
                        v-model="second_sales_contact_id"
                        :items="salesContactList"
                        item-title="code"
                        item-value="id"
                        :error-messages="errors.second_sales_contact_id"
                        density="compact"
                        variant="outlined"
                        @update:model-value="changeSecondSalesContact"
                        clearable
                      />
                    </v-col>

                    <!-- Second Beneficiary -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Second Beneficiary*"
                        v-model="second_beneficiary_id"
                        :items="supplierList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.second_beneficiary_id"
                        density="compact"
                        variant="outlined"
                        readonly
                        clearable
                      />
                    </v-col>

                    <!-- Second Beneficiary Amount -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Second Beneficiary Amount*"
                        type="number"
                        v-model.number="second_beneficiary_amount"
                        :error-messages="errors.second_beneficiary_amount"
                        density="compact"
                        variant="outlined"
                        readonly
                      />
                    </v-col>

                    <!-- Third Sales Contact -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Third Sales Contact"
                        v-model="third_sales_contact_id"
                        :items="salesContactList"
                        item-title="code"
                        item-value="id"
                        :error-messages="errors.third_sales_contact_id"
                        density="compact"
                        variant="outlined"
                        @update:model-value="changeThirdSalesContact"
                        clearable
                      />
                    </v-col>

                    <!-- Third Beneficiary -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Third Beneficiary"
                        v-model="third_beneficiary_id"
                        :items="supplierList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.third_beneficiary_id"
                        density="compact"
                        variant="outlined"
                        readonly
                        clearable
                      />
                    </v-col>

                    <!-- Third Beneficiary Amount -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Third Beneficiary Amount"
                        type="number"
                        v-model.number="third_beneficiary_amount"
                        :error-messages="errors.third_beneficiary_amount"
                        density="compact"
                        variant="outlined"
                        readonly
                      />
                    </v-col>

                    
                    <!-- Fourth Sales Contact -->
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Fourth Sales Contact"
                        v-model="fourth_sales_contact_id"
                        :items="salesContactList"
                        item-title="code"
                        item-value="id"
                        :error-messages="errors.fourth_sales_contact_id"
                        density="compact"
                        variant="outlined"
                        @update:model-value="changeFourthSalesContact"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-autocomplete
                        label="Fourth Beneficiary"
                        v-model="fourth_beneficiary_id"
                        :items="supplierList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.fourth_beneficiary_id"
                        density="compact"
                        variant="outlined"
                        readonly
                        clearable
                      />
                    </v-col>

                    <!-- Fourth Beneficiary Amount -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Fourth Beneficiary Amount"
                        type="number"
                        v-model.number="fourth_beneficiary_amount"
                        :error-messages="errors.fourth_beneficiary_amount"
                        density="compact"
                        variant="outlined"
                        readonly
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- ACTION BUTTONS -->
          <v-col cols="12" class="mt-3">
            <v-card-actions class="justify-end">
              <v-btn class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
              <v-btn class="bg-primary" @click="submitForm(1)">
                {{ isEdit ? 'Update' : 'Save' }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import * as yup from "yup";


const store = useStore();
const route = useRoute();
const router = useRouter();
const ttAllocationId = route.params.id;

const panel = ref([0]);
const isEdit = ref(false);

// Master Fields
const tt_allocation_master_id = ref(null);
const master_sales_contact_id = ref(null);
const buyer_id = ref(null);
const buying_house_bank_id = ref(null);
const ftt_reference = ref("");
const tt_utilization_amount = ref(0);
const first_beneficiary_amount = ref(0);
const second_sales_contact_id = ref(null);
const third_sales_contact_id = ref(null);
const fourth_sales_contact_id = ref(null);
const second_beneficiary_id = ref(null);
const third_beneficiary_id = ref(null);
const fourth_beneficiary_id = ref(null);
const second_beneficiary_amount = ref(0);
const third_beneficiary_amount = ref(0);
const fourth_beneficiary_amount = ref(0);
const status = ref(1);

const errors = ref({});

// Lists
const masterSalesContactList = computed(() => store.getters.getMasterSalesContactList || []);
const salesContactList = computed(() => store.getters.getSalesContactList || []);
const buyerList = computed(() => store.getters.getCustomerList || []);
const bankList = computed(() => store.getters.getLcBankList || []);
const supplierList = computed(() => store.getters.getSupplierList || []);

// Validation schema
const schema = yup.object({ 
  master_sales_contact_id: yup.number().required("Master Sales Contact is required"), 
  buyer_id: yup.number().required("Buyer is required"), 
  buying_house_bank_id: yup.number().required("Buying House Bank is required"), 
  ftt_reference: yup.string().required("FTT Reference is required"), 
  tt_utilization_amount: yup.number().required("TT Utilization Amount is required").min(0, "Cannot be negative"),
  first_beneficiary_amount: yup.number().required("First Beneficiary Amount is required").min(0), 
  second_sales_contact_id: yup.number().required("Second Sales Contact is required"), 
  second_beneficiary_id: yup.number().required("Second Beneficiary is required"), 
  second_beneficiary_amount: yup.number().required("Second Beneficiary Amount is required").min(0), 
  // third_sales_contact_id: yup.number().required("Third Sales Contact is required"), 
  // third_beneficiary_id: yup.number().required("Third Beneficiary is required"), 
  // third_beneficiary_amount: yup.number().required("Third Beneficiary Amount is required").min(0), 
});

// Fetch initial data
async function getInitialData() {
  store.commit("SET_LOADING", { color: "primary" });
  await store.dispatch("getMasterSalesContactList");
  await store.dispatch("getSalesContactList");
  await store.dispatch("getCustomerList");
  await store.dispatch("getLcBankList");
  await store.dispatch("getSupplierList");
  store.commit("UNSET_LOADING");

  if (ttAllocationId) {
    isEdit.value = true;
    const res = await store.dispatch("getTtAllocation", ttAllocationId);
    const data = res;
    //console.log(data);
    master_sales_contact_id.value = data.master_sales_contact_id;
    tt_allocation_master_id.value = data.id;
    buyer_id.value = data.buyer_id;
    buying_house_bank_id.value = data.buying_house_bank_id;
    ftt_reference.value = data?.details?.ftt_reference;
    tt_utilization_amount.value = data?.details?.tt_utilization_amount;
    first_beneficiary_amount.value = data?.details?.first_beneficiary_amount;
    second_sales_contact_id.value = data?.details?.second_sales_contact_id;
    third_sales_contact_id.value = data?.details?.third_sales_contact_id;
    fourth_sales_contact_id.value = data?.details?.fourth_sales_contact_id;
    second_beneficiary_id.value = data?.details?.second_beneficiary_id;
    third_beneficiary_id.value = data?.details?.third_beneficiary_id;
    fourth_beneficiary_id.value = data?.details?.fourth_beneficiary_id;
    second_beneficiary_amount.value = data?.details?.second_beneficiary_amount;
    third_beneficiary_amount.value = data?.details?.third_beneficiary_amount;
    fourth_beneficiary_amount.value = data?.details?.fourth_beneficiary_amount;
    status.value = data?.status;
  }
}

// Handle submit
async function submitForm(status) {
  errors.value = {};

  const payload = {
    tt_allocation_master_id: tt_allocation_master_id.value,
    master_sales_contact_id: master_sales_contact_id.value,
    buyer_id: buyer_id.value,
    buying_house_bank_id: buying_house_bank_id.value,
    ftt_reference: ftt_reference.value,
    tt_utilization_amount: tt_utilization_amount.value,
    first_beneficiary_amount: first_beneficiary_amount.value,
    second_sales_contact_id: second_sales_contact_id.value,
    third_sales_contact_id: third_sales_contact_id.value,
    fourth_sales_contact_id: fourth_sales_contact_id.value,
    second_beneficiary_id: second_beneficiary_id.value,
    third_beneficiary_id: third_beneficiary_id.value,
    fourth_beneficiary_id: fourth_beneficiary_id.value,
    second_beneficiary_amount: second_beneficiary_amount.value,
    third_beneficiary_amount: third_beneficiary_amount.value,
    fourth_beneficiary_amount: fourth_beneficiary_amount.value,
    status: status,
  };

  try {
    await schema.validate(payload, { abortEarly: false });
    if (isEdit.value) {
      await store.dispatch("updateTtAllocation", { id: ttAllocationId, data: payload });
      toast.success("TT Allocation Updated");
    } else {
      await store.dispatch("saveTtAllocation", payload);
      toast.success("TT Allocation Saved");
    }
    router.push({ name: "tt-allocation-record" });
  } catch (err) {
    if (err.inner) {
      err.inner.forEach(e => {
        errors.value[e.path] = e.message;
      });
    }
  }
}

// Change events for second/third sales contacts
function changeSecondSalesContact(id) {
  const selected = salesContactList.value.find(s => s.id === id);
  second_beneficiary_id.value = selected?.supplier_id ?? null;
  second_beneficiary_amount.value = selected?.total_amount ?? 0;
}

function changeThirdSalesContact(id) {
  const selected = salesContactList.value.find(s => s.id === id);
  third_beneficiary_id.value = selected?.supplier_id ?? null;
  third_beneficiary_amount.value = selected?.total_amount ?? 0;
}

function changeFourthSalesContact(id) {
  const selected = salesContactList.value.find(s => s.id === id);
  fourth_beneficiary_id.value = selected?.supplier_id ?? null;
  fourth_beneficiary_amount.value = selected?.total_amount ?? 0;
}

function changeMasterSalesContact(id) {
  const selected = masterSalesContactList.value.find(s => s.id === id);
  buyer_id.value = selected?.buyer_id ?? null;
  tt_utilization_amount.value = selected?.total_amount ?? 0;
  first_beneficiary_amount.value = selected?.total_amount ?? 0;
}

onMounted(getInitialData);
</script>

<style>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}

.v-btn {
  min-width: 80px;
}
</style>
